// extracted by mini-css-extract-plugin
export default {"container":"Home_container__MjOfV","middle":"Home_middle__hmnOY","homeText":"Home_homeText__1FRL8","scroll":"Home_scroll__T6tHk"};